export default __webpack_public_path__ + "static/media/1-2.5459586b.png";